import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4 border-bottom" }
const _hoisted_5 = { class: "d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "default-table-area style-two default-table-width" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle mb-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "badge bg-secondary bg-opacity-10 text-secondary font-monospace fs-12 px-2 py-1" }
const _hoisted_12 = { class: "fw-semibold text-dark fs-14 mb-1" }
const _hoisted_13 = { class: "badge bg-primary bg-opacity-10 text-primary fs-11 px-2 py-1" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "fs-13" }
const _hoisted_16 = { class: "text-dark ms-1" }
const _hoisted_17 = { class: "fs-13 mt-1" }
const _hoisted_18 = { class: "text-dark ms-1" }
const _hoisted_19 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_20 = { class: "badge bg-secondary bg-opacity-10 text-secondary fs-11 px-2 py-1" }
const _hoisted_21 = { class: "badge bg-info bg-opacity-10 text-info fs-12 px-2 py-1" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-end gap-1" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Similarity Profiles",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, [
            _createElementVNode("h5", { class: "mb-1 fs-16 fw-semibold text-dark" }, "Turnitin Benchmark Profiles"),
            _createElementVNode("p", { class: "text-muted fs-13 mb-0" }, "Kelola standar batas toleransi similaritas Turnitin dan aturan eksklusi per klasifikasi dokumen.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "position-relative table-src-form me-0",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Cari kode atau nama...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
            ], 32),
            _createVNode(_component_RouterLink, {
              to: "/similarity-profiles/create",
              class: "btn btn-primary py-2 px-3 fs-14 fw-medium rounded-3"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "d-flex align-items-center gap-1" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "add"),
                  _createElementVNode("span", null, "Add New Profile")
                ], -1)
              ])),
              _: 1
            })
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "p-3 bg-light-subtle border-bottom fs-13 text-muted d-flex align-items-center gap-2" }, [
          _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary" }, "info"),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Catatan Keamanan Data:"),
            _createTextVNode(" Mengubah atau menghapus profil di sini "),
            _createElementVNode("strong", null, "tidak akan mengubah"),
            _createTextVNode(" status atau nilai protokol order yang telah masuk sebelumnya. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"140px"}
                  }, "Profile Code"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"220px"}
                  }, "Profile Name & Classification"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"160px"}
                  }, "Threshold Limits"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"180px"}
                  }, "Exclusion Rules"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"110px"}
                  }, "Orders"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"100px"}
                  }, "Status"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-end",
                    style: {"min-width":"100px"}
                  }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[5] || (_cache[5] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center py-5 text-muted"
                      }, [
                        _createElementVNode("div", {
                          class: "spinner-border spinner-border-sm text-primary me-2",
                          role: "status"
                        }),
                        _createTextVNode(" Memuat data profil similaritas... ")
                      ], -1)
                    ])))
                  : (_ctx.filteredProfiles.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _cache[6] || (_cache[6] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "text-center py-5 text-muted"
                        }, " Tidak ada profil similaritas yang sesuai. ", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredProfiles, (profile) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: profile.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(profile.profile_code), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(profile.profile_name), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(profile.service_classification), 1),
                            (profile.description)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "fs-12 text-muted mb-0 mt-1 text-truncate",
                                  style: {"max-width":"280px"},
                                  title: profile.description
                                }, _toDisplayString(profile.description), 9, _hoisted_14))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted" }, "Max Overall:", -1)),
                              _createElementVNode("strong", _hoisted_16, _toDisplayString(profile.default_max_overall) + "%", 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted" }, "Max Single:", -1)),
                              _createElementVNode("strong", _hoisted_18, _toDisplayString(profile.default_max_single_source) + "%", 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge fs-11 px-2 py-1", profile.exclude_bibliography ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                              }, " Biblio: " + _toDisplayString(profile.exclude_bibliography ? 'Exclude' : 'Include'), 3),
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge fs-11 px-2 py-1", profile.exclude_quotes ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                              }, " Quotes: " + _toDisplayString(profile.exclude_quotes ? 'Exclude' : 'Include'), 3),
                              _createElementVNode("span", _hoisted_20, " Matches: " + _toDisplayString(_ctx.formatSmallMatches(profile)), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(profile.orders_count ?? 0) + " order ", 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge fs-12 px-2 py-1", profile.is_active ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                            }, _toDisplayString(profile.is_active ? 'Active' : 'Inactive'), 3)
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_RouterLink, {
                                to: '/similarity-profiles/' + profile.id + '/edit',
                                class: "btn btn-sm btn-outline-secondary p-1 border-0",
                                title: "Edit Profile"
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-body" }, "edit", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deleteProfile(profile)),
                                class: "btn btn-sm btn-outline-danger p-1 border-0",
                                title: "Delete Profile"
                              }, _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-danger" }, "delete", -1)
                              ]), 8, _hoisted_24)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}